import { useQuery } from '@tanstack/react-query';
import type { paths } from '../../../generated/apiClient';
import { repositoryGetter } from '../../../repository/container';
import { hasSessionCookieAuthCredential } from '../../../utils';
import { UseQueryDefaultOptions } from '../common';
import { useActiveGrantExpiryRefresh } from './activeGrantExpiry';

const repository = repositoryGetter.Auth();
const apiPath: Extract<keyof paths, '/auth/get-initial-auth-info'> = '/auth/get-initial-auth-info';
export const queryKey = (props: Props) => [apiPath, props];

type Props = { uid: string | undefined; enabled?: boolean | undefined };

export const _getInitialAuthInfo = (props: Props) => {
  const { uid } = props;
  const enabled = props.enabled ?? (uid !== undefined || hasSessionCookieAuthCredential());

  const { data, isPending, refetch } = useQuery({
    queryKey: queryKey(props),
    queryFn: async ({ signal }) => {
      if (!enabled) return null;
      return repository.getInitialAuthInfo({ signal });
    },
    ...UseQueryDefaultOptions,
    throwOnError: false,
    // 5 min
    staleTime: 1000 * 60 * 5,
    // 10 min
    gcTime: 1000 * 60 * 10,
    enabled,
  });

  const authInfo = useActiveGrantExpiryRefresh({ authInfo: data ?? undefined, refetch });

  return { authInfo, isPending, refetch };
};
